import RedPoint from "../../../../../../../src/entities/RedPoint";
import { Coord, RedPointRadianInfo } from "../../../../../../../src/types/Interface";
import generatePoints from "../../../../../../../src/utils/generator/generatePoints";
import getAngleBetweenPoints from "../../../../../../../src/utils/math/getAngleBtwPoints";
import { normalizeRadian } from "../../../../../../../src/utils/math/normalizeRadian";
import { THRESHOLD_RADIANS } from "../../../types/Config";


export function generateChordPoints(cCoord: Coord, circleRadius: number, pointRadian: number, intersecRadius: number) {
    if (!cCoord || !circleRadius || !pointRadian || !intersecRadius) {
        return Array(3).fill({ x: 0, y: 0 });
    }
    const intersecCoord = generatePoints(cCoord, [pointRadian], intersecRadius)[0];
    const sideLength = Math.sqrt(Math.pow(circleRadius, 2) - Math.pow(intersecRadius, 2));

    const getCoord = (radian: number) => ({
        x: intersecCoord.x + Math.cos(radian) * sideLength,
        y: intersecCoord.y + Math.sin(radian) * sideLength
    });

    return [getCoord(pointRadian + Math.PI / 2), intersecCoord, getCoord(pointRadian - Math.PI / 2)];
}

export function findIntersecCoord(cCoord: Coord, chordA: Coord[], chordB: Coord[]) {
    // y = m * x + b
    const slopeA = Math.tan(normalizeRadian(getAngleBetweenPoints(chordA[1], cCoord) + Math.PI / 2));
    const slopeB = Math.tan(normalizeRadian(getAngleBetweenPoints(chordB[1], cCoord) + Math.PI / 2));

    // b = y - m * x
    const bA = chordA[1].y - slopeA * chordA[1].x;
    const bB = chordB[1].y - slopeB * chordB[1].x;

    // x = (b2 - b1) / (m1 - m2)
    const x = Number(((bB - bA) / (slopeA - slopeB)).toFixed(2));
    const y = Number((slopeB * x + bB).toFixed(2));
    return { x, y }
}

export function getShortestDelta(a: number, b: number): number {
  let delta = a - b;
  while (delta > Math.PI) delta -= 2 * Math.PI;
  while (delta < -Math.PI) delta += 2 * Math.PI;
  return delta;
}

export function getPointInfoArr(
  pointInfoArr: RedPointRadianInfo[],
  RedPointsArr: RedPoint[],
  pointRadians: number[]
) {
  let _pointInfoArr: RedPointRadianInfo[] = [...pointInfoArr];

  if (pointInfoArr.length === 1) {
    const index = RedPointsArr.findIndex(point => point.tag === pointInfoArr[0].pTag);
    const otherIndex = index === 0 ? 1 : 0;

    const firstRadian = normalizeRadian(pointInfoArr[0].radian);
    const secondOriginalRadian = normalizeRadian(pointRadians[otherIndex]);

    const delta = getShortestDelta(firstRadian, secondOriginalRadian);
    let secondRadian = secondOriginalRadian;

    if (Math.abs(delta) > THRESHOLD_RADIANS.max) {
      // Çok uzaksa, max sınırına getir
      secondRadian = delta > 0
        ? firstRadian - THRESHOLD_RADIANS.max
        : firstRadian + THRESHOLD_RADIANS.max;
    } else if (Math.abs(delta) < THRESHOLD_RADIANS.min) {
      // Çok yakınsa, min mesafeye aç
      secondRadian = delta > 0
        ? firstRadian - THRESHOLD_RADIANS.min
        : firstRadian + THRESHOLD_RADIANS.min;
    }

    _pointInfoArr.push({ pTag: RedPointsArr[otherIndex].tag, radian: secondRadian });
  }

  return _pointInfoArr;
}